































































































































































































import {
  defineComponent, PropType, reactive, computed, onMounted, toRefs, watch,
} from '@vue/composition-api'

import { toPrettyJson } from '@/lib/utils/toPrettyJson'

// The component props should implement this interface ...read below.
import { ErrorDisplay } from '@/components/types/ErrorDisplay'

export default defineComponent({
  components: {
    //
  },
  // Define props: Any error handler component should conform to ErrorDisplay
  // interface. Unfortunately the vue-2 composition-api plugin does
  // not provide a fully developed way to integrate ts interfaces with
  // component props, which means that you manually have to keep some
  // of the props below in accordance with the ErrorDisplay interface.
  props: {
    title: {
      type: String,
      default: '',
    },
    /**
     * The main error message that will be shown to the
     * user.
     */
    message: {
      type: String,
      default: 'Der opstod en fejl - handlingen blev ikke gennemført.',
    },
    /**
     * An optional extra message to the user regarding remediating
     * actions, e.g. whom to contact. Displayed in smaller fonts,
     * if present.
     */
    actionMessage: {
      type: String,
      default: '',
    },
    /**
     * An optional js key/val object holding structured
     * error details ('error-excerpt') you may want to
     * show the user.
     * If provided a this information will be available
     * to the user as the top most part of an expandable
     * details section.
     */
    excerpt: {
      type: Object as PropType<Pick<ErrorDisplay, 'excerpt'>>,
      default: () => ({}),
    },
    /**
     * An optional js Error object
     * If provided a deserialized version of the error
     * will be available to the user in an expandable
     * details section.
     */
    error: Error,
    /**
     * If not empty string, a button with the string will be shown
     * when clicked the component will emit 'acknowledged'
     */
    prompt: {
      type: String,
      default: '',
    },
    /**
     * Hide the component (animations retained)
     * when the prompt button is being clicked.
     */
    hideOnAcknowledged: {
      type: Boolean,
      default: true,
    },
    /**
     * Hide the component from parent (animations retained)
     * Can be used by the parent to dynamically hide and
     * show the document(there is probably a better vue way
     * to do this while retaining animationsI just couldn't
     * figure it out)
     */
    hide: {
      type: Boolean,
      default: false,
    },
  },

  setup(props, context) {
    function formatExcerpt(eExcerpt: Pick<ErrorDisplay, 'excerpt'> | undefined) {
      if (eExcerpt === undefined) return ''
      return JSON.stringify(eExcerpt, null, 2)
    }

    /**
     * Converts an Error instance to a 'pretty printable' Json string
     */
    function formatError(e: Error | undefined): string {
      if (e === undefined) return ''
      return toPrettyJson(e)
    }

    // Set up state
    const state = reactive({
      myExcerpt: computed(() => formatExcerpt(props.excerpt)),
      formattedError: computed(() => formatError(props.error)),
      show: false,
      showDetails: false,
      showFullError: false,
      transitionStarted: false,
    })

    const icon = computed(() => {
      if (context.root.$vuetify.breakpoint.xs) return false
      return 'mdi-cloud-off-outline'
    })

    function show(showIt = true): void {
      // flag to tell the handler that transition has not
      // started yet
      state.transitionStarted = false
      state.show = showIt
    }

    // show referred to after mount to have transitions kick in
    onMounted(() => {
      show(!props.hide)
    })

    function hasExcerpt(): boolean {
      return Object.keys(props.excerpt).length !== 0
    }

    function hasError(): boolean {
      return props.error !== undefined
    }

    function hasDetails(): boolean {
      return hasError() || hasExcerpt()
    }

    /**
     * Emit events when shown/hidden
     */
    function handleTransitionEvent(transEvent: string) {
      // state.transitionStarted is a flag to prevent
      // the events from firing twice (which they apparently do):
      // The main `show` methods sets this flag to false when
      // there is a change in state.show. The first event received
      // sets it to true and we then skip for the next event(s)
      if (transEvent === 'afterEnter' && !state.transitionStarted) {
        state.transitionStarted = true
        context.emit('shown')
      }
      if (transEvent === 'afterLeave' && !state.transitionStarted) {
        state.transitionStarted = true
        context.emit('hidden')
      }
    }

    function toggleDetails(): void {
      if (state.showDetails) state.showFullError = false
      state.showDetails = !state.showDetails
      if (!hasExcerpt()) {
        state.showFullError = true
      }
    }

    function toggleFullError(): void {
      state.showFullError = !state.showFullError
    }

    function acknowledge(): void {
      if (props.hideOnAcknowledged) show(false)
      context.emit('acknowledged')
    }

    // Listen for changes to hide prop (which is false by default)
    watch(() => props.hide, (newVal) => show(!newVal))

    // Make stuff available for the template
    return {
      ...toRefs(state),
      acknowledge,
      toggleDetails,
      toggleFullError,
      hasDetails,
      hasError,
      hasExcerpt,
      icon,
      handleTransitionEvent,

    }
  },
})

